import React from 'react';

function About() {
  return (
    <section id="about" className="about">
      <h2>About Me</h2>
      <div className="about-content">
        <div className="about-text">
          <p>Hello! I'm Phoenix Kilgore, a passionate creator dedicated to excellence and innovation.</p>
          <p>With expertise in [Your Skills], I help bring visions to life through creative solutions.</p>
        </div>
        <div className="skills">
          <div className="skill">
            <i className="fas fa-code"></i>
            <h3>Development</h3>
          </div>
          <div className="skill">
            <i className="fas fa-paint-brush"></i>
            <h3>Design</h3>
          </div>
          <div className="skill">
            <i className="fas fa-lightbulb"></i>
            <h3>Strategy</h3>
          </div>
        </div>
      </div>
    </section>
  );
}

export default About; 